import { render, staticRenderFns } from "./alarm.vue?vue&type=template&id=6792950c&scoped=true&"
import script from "./alarm.js?vue&type=script&lang=js&"
export * from "./alarm.js?vue&type=script&lang=js&"
import style0 from "./alarm.css?vue&type=style&index=0&id=6792950c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6792950c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
